/** Names of the undoable user commands; the UI maps them to localized text ("Undo: ..."). */
export const CommandLabel = {
  CreateBlock: 'createBlock',
  UpdateBlock: 'updateBlock',
  UpdateBlockSpans: 'updateBlockSpans',
  MoveBlocksToDate: 'moveBlocksToDate',
  SetCountRank: 'setCountRank',
  SetGroupProject: 'setGroupProject',
  /** The picker's single commit (project, title, note, span in one undo step, 2026-10b §2.5). */
  EditBlocks: 'editBlocks',
  /** Create a project and assign it to blocks (or create a block in it) in one undo step (§2.5). */
  CreateProjectAndAssign: 'createProjectAndAssign',
  ClearBlock: 'clearBlock',
  ClearBlocks: 'clearBlocks',
  ConfirmDraft: 'confirmDraft',
  ConfirmAllDrafts: 'confirmAllDrafts',
  ClearDrafts: 'clearDrafts',
  ToggleCheckin: 'toggleCheckin',
  SetCheckinDoneAt: 'setCheckinDoneAt',
  /** The check-in card's edit mode: several occurrences of a day in one undo step. */
  EditCheckinDay: 'editCheckinDay',
  SaveNote: 'saveNote',
  UpsertProject: 'upsertProject',
  SetProjectActive: 'setProjectActive',
  /** Drag sorting of the project list (settings → projects): new `sort` values in one undo step. */
  ReorderProjects: 'reorderProjects',
  DeleteProject: 'deleteProject',
  UpsertCheckinItem: 'upsertCheckinItem',
  SetCheckinItemActive: 'setCheckinItemActive',
  /** Star or unstar a check-in item: starred items lead the settings list. */
  SetCheckinItemStarred: 'setCheckinItemStarred',
  DeleteCheckinItem: 'deleteCheckinItem',
  UpsertTemplate: 'upsertTemplate',
  DeleteTemplate: 'deleteTemplate',
  UpsertImportantDate: 'upsertImportantDate',
  SetImportantDateActive: 'setImportantDateActive',
  DeleteImportantDate: 'deleteImportantDate',
  SetSetting: 'setSetting',
  SetSettings: 'setSettings',
  ChangeDayStart: 'changeDayStart',
  ResolveOverlap: 'resolveOverlap',
} as const;
export type CommandLabel = (typeof CommandLabel)[keyof typeof CommandLabel];
